import { LogLevel } from "@azure/msal-browser";

// Comprehensive error suppression for common MSAL/CIAM issues
const suppressError = (message) => {
  const suppressPatterns = [
    '_ReportFailure',
    'oauth2/v2.0/authorize',
    'offline_access',
    '503 response',
    'ECONNRESET',
    'Failed to load external resource',
    'aadcdn.msauth.net',
    'converged.v2.login',
    'Could not read source map',
    'Unexpected 503 response',
    'reloading from fallback CDN endpoint',
    'BSSO Telemetry',
    'bssoNotSupported',
    'msLaunchUri is not available'
  ];
  
  return suppressPatterns.some(pattern => message.includes(pattern));
};

// Configuration object for MSAL authentication with multitenant support
// Uses "common" endpoint to allow sign-ins from any organizational directory or personal accounts
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "f8f44247-d62e-461d-9ce2-332e2815da2e",
    authority: import.meta.env.VITE_AZURE_AUTHORITY || "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        
        // Suppress common MSAL/CIAM errors that don't affect functionality
        if (suppressError(message)) {
          return;
        }
        
        switch (level) {
          case LogLevel.Error:
            // Suppress all MSAL errors in production
            return;
          case LogLevel.Info:
            // Suppress all info logging in production
            return;
          case LogLevel.Verbose:
            // Suppress all verbose logging
            return;
          case LogLevel.Warning:
            // Suppress all warnings in production
            return;
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false
    },
    allowNativeBroker: false,
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000
  }
};

// Login request scopes for multitenant Azure AD authentication and personal accounts
// Using standard OpenID Connect and Microsoft Graph scopes
export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
  prompt: "select_account"
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};